// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3UzqY","colBig":"styles_colBig__2BnB7","colSmall":"styles_colSmall__1o1P9"};